(function () {
  // ─── Configuration ───────────────────────────────────────────────────────────
  // Set to true when the summer bundle is ready to go live.
  var ENABLED = true;
  if (!ENABLED) return;

  var BUNDLE_VARIANT_ID = 53459188187443; // Sweet Chipotle 1lb variant ID
  var GIFT_VARIANT_ID   = 53469642785075; // Lime N Lemon shaker variant ID

  // Matches the "Customer buys: 9" threshold in the Shopify automatic discount.
  var BUNDLE_MIN_QTY = 1;

  // TODO: inspect Zipify's live drawer element and update this selector if the
  // banner doesn't appear. Right-click the open drawer → Inspect → copy a
  // unique attribute or class and replace the selector below.
  var ZIPIFY_DRAWER_SELECTOR = '.ocu-cart-drawer';

  var GIFT_PROP_KEY = '_gift';
  var GIFT_PROP_VAL = 'summer-bundle';
  var BANNER_ID     = 'acme-bxgy-banner';
  // ─────────────────────────────────────────────────────────────────────────────

  // ─── Cart helpers ────────────────────────────────────────────────────────────

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function bundleQtyInCart(cart) {
    var item = cart.items.find(function (i) { return i.variant_id === BUNDLE_VARIANT_ID; });
    return item ? item.quantity : 0;
  }

  function cartHasGift(cart) {
    return cart.items.some(function (i) {
      return i.variant_id === GIFT_VARIANT_ID &&
             i.properties &&
             i.properties[GIFT_PROP_KEY] === GIFT_PROP_VAL;
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROP_KEY]: GIFT_PROP_VAL }
        }]
      })
    });
  }

  function removeGift(cart) {
    var giftItem = cart.items.find(function (i) {
      return i.variant_id === GIFT_VARIANT_ID &&
             i.properties &&
             i.properties[GIFT_PROP_KEY] === GIFT_PROP_VAL;
    });
    if (!giftItem) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 0 })
    });
  }

  function zipifyRefresh() {
    if (window.Zipify && Zipify.Cart && Zipify.Cart.instance &&
        typeof Zipify.Cart.instance.updateCart === 'function') {
      Zipify.Cart.instance.updateCart();
    }
  }

  // ─── Sync logic ──────────────────────────────────────────────────────────────
  // Debounced so rapid event bursts (theme pubsub, Zipify re-renders, etc.)
  // collapse into a single cart check after the dust settles.

  var syncTimer  = null;
  var syncing    = false;

  function syncGift() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(doSync, 400);
  }

  function doSync() {
    if (syncing) return;
    syncing = true;

    getCart().then(function (cart) {
      var qualifies = bundleQtyInCart(cart) >= BUNDLE_MIN_QTY;
      var hasGift   = cartHasGift(cart);

      if (qualifies && !hasGift) {
        addGift()
          .then(function () { syncing = false; zipifyRefresh(); updateBanner(); })
          .catch(function () { syncing = false; });
      } else if (!qualifies && hasGift) {
        removeGift(cart)
          .then(function () { syncing = false; zipifyRefresh(); updateBanner(); })
          .catch(function () { syncing = false; });
      } else {
        syncing = false;
      }
    }).catch(function () { syncing = false; });
  }

  // ─── Drawer banner ───────────────────────────────────────────────────────────

  function createBanner() {
    var el = document.createElement('div');
    el.id = BANNER_ID;
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = [
      'position:relative',
      'z-index:2147483647',
      'background:#ffd535',
      'color:#0c1132',
      'font-size:13px',
      'font-weight:700',
      'line-height:1.4',
      'text-align:center',
      'padding:10px 16px',
      'letter-spacing:0.03em',
      'width:100%',
      'box-sizing:border-box',
      'white-space:normal',
      'overflow:visible'
    ].join(';');
    el.innerHTML = '🎁 Free Sample Sized Mystery Blend added to your order! <span style="font-weight:400;opacity:0.75;">If it doesn\'t appear, refresh the page.</span>';
    return el;
  }

  function updateBanner() {
    var drawer = document.querySelector(ZIPIFY_DRAWER_SELECTOR);
    if (!drawer) return;

    getCart().then(function (cart) {
      var existing  = document.getElementById(BANNER_ID);
      var qualifies = bundleQtyInCart(cart) >= BUNDLE_MIN_QTY;

      if (qualifies && !existing) {
        drawer.insertBefore(createBanner(), drawer.firstChild);
      } else if (!qualifies && existing) {
        existing.remove();
      }
    });
  }

  // ─── DOM observer ────────────────────────────────────────────────────────────
  // Catches Zipify ATC — when Zipify opens its drawer the DOM mutates and we
  // run a debounced cart sync. Also re-injects the banner if Zipify wipes it.

  var lastDrawerState = false;

  var drawerObserver = new MutationObserver(function () {
    var drawer     = document.querySelector(ZIPIFY_DRAWER_SELECTOR);
    var drawerOpen = !!drawer;

    if (drawerOpen && !lastDrawerState) {
      syncGift();
    }
    lastDrawerState = drawerOpen;

    if (drawer && !document.getElementById(BANNER_ID)) {
      updateBanner();
    }
  });

  drawerObserver.observe(document.body, { childList: true, subtree: true });

  // ─── Event hooks ─────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    // cart-update fires when the theme's cart changes — use this as the trigger.
    // Deliberately NOT subscribing to cart:rerender as that fires after our own
    // onCartChanged and creates a feedback loop that removes the gift.
    if (typeof subscribe === 'function') {
      subscribe('cart-update', syncGift);
    }

    // Initial check — handles page load when bundle is already in cart.
    syncGift();
  });
})();
